export const DEFAULT_ACTION_PREFIX = 'KARNOTT_IMPLEMENTS';
export const DEFAULT_SERVICE_NAME = 'implements';
export const DEFAULT_ACCESSOR_CHAIN = [DEFAULT_SERVICE_NAME];
